import React from "react";

const PoweredBy = () => {
  return (
    <div className={`powered-by-connectel`}>
      <img height="16" src="/motion.png" alt="Connectel logo" className="h-6" />
      <a className="no-link-decor" href="https://connectel.io/" target="_blank" rel="noreferrer">
        Powered by Connectel
      </a>
    </div>
  );
};

export default PoweredBy;
